// extracted by mini-css-extract-plugin
export default {"main":"angelsDreams_main__hAeKV","audio":"angelsDreams_audio__0GG9i","audioColumns":"angelsDreams_audioColumns__V-BcZ","audioFile":"angelsDreams_audioFile__yt+PH"};